export default __webpack_public_path__ + "static/media/Käfer-auf-Blatt.803899b7.webp";